import React, { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

export interface GridProps {
  className?: string;
  gap?: number;
  noGap?: boolean;
  onClick?: () => void;
}

const Grid: FunctionComponent<GridProps> = ({ className, children, onClick }) => {
  return <div className={className || ''} onClick={onClick}>{children}</div>;
};

export default styled(Grid)`
  display: grid;
  grid-gap: ${(props) =>
    props.noGap
      ? '0'
      : props.gap
      ? css`
          ${props.gap}px
        `
      : '3px'};
`;
